var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-tooltip",style:({ backgroundColor: _vm.color })},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.data.customerName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }